export default "__VITE_ASSET__2E2lxQh___"